import {
  VAlert, VApp, VAppBar, VBottomSheet, VBtn, VBtnToggle, VCard, VCardActions,
  VCardSubtitle, VCardText, VCardTitle, VCheckbox, VChip, VChipGroup, VCol,
  VContainer, VDialog, VDivider, VExpansionPanel, VExpansionPanelText,
  VExpansionPanels, VExpansionPanelTitle, VIcon, VList, VListItem, VListItemTitle,
  VMain, VMenu, VNavigationDrawer, VProgressCircular, VRow, VSelect, VSheet,
  VSkeletonLoader, VSpacer, VSwitch, VTab, VTabs, VTabsWindow, VTabsWindowItem,
  VTextarea, VTextField, VTooltip,
} from 'vuetify/components'

export const vuetifyComponents = {
  VAlert, VApp, VAppBar, VBottomSheet, VBtn, VBtnToggle, VCard, VCardActions,
  VCardSubtitle, VCardText, VCardTitle, VCheckbox, VChip, VChipGroup, VCol,
  VContainer, VDialog, VDivider, VExpansionPanel, VExpansionPanelText,
  VExpansionPanels, VExpansionPanelTitle, VIcon, VList, VListItem, VListItemTitle,
  VMain, VMenu, VNavigationDrawer, VProgressCircular, VRow, VSelect, VSheet,
  VSkeletonLoader, VSpacer, VSwitch, VTab, VTabs, VTabsWindow, VTabsWindowItem,
  VTextarea, VTextField, VTooltip,
}
